import { useTemplatesContext } from '@components/Contexts/TemplatesContext';

export const useFiltersShouldClearSearch = (): boolean => {
  const {
    state: { numberOfResults, filters },
  } = useTemplatesContext();

  return !numberOfResults && Boolean(filters.search);
};
